<template>
    <div class="web" v-loading="loading">
        <div class="post">
            <el-row :gutter="30">
                <el-form ref="form" :model="postForm" :rules="rules">
                    <el-col :span="12">
                        <el-form-item label="职位名称" class="boxHei" prop="job_name">
                            <el-select class="boxWid" v-model="postForm.job_name" placeholder="请选择职位名称" @change="changeJobName">
                                <el-option
                                    v-for="(item, index) in jobNameList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="招聘人数" class="boxHei" prop="person_number">
                            <el-select class="boxWid" v-model="postForm.person_number" placeholder="请选择招聘人数">
                                <el-option
                                    v-for="(item, index) in peoNumList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="薪资待遇" class="boxHei" prop="salary_package">
                            <div>
                                <br />
                                <el-row :gutter="10">
                                    <el-col :span="10">
                                        <el-select v-model="postForm.moneyMin" placeholder="请选择薪资" @change="moneyChange">
                                            <el-option
                                                v-for="(item,index) in moneyMinList"
                                                :key="index"
                                                :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                    <el-col v-if="postForm.salary_package != '面议'" :span="4" style="text-align: center;">至</el-col>
                                    <el-col :span="10" v-if="postForm.salary_package != '面议'">
                                        <el-select v-model="postForm.moneyMax" placeholder="请选择薪资" @change="moneyMaxChange">
                                            <el-option
                                                v-for="(item,index) in moneyMaxList"
                                                :key="index"
                                                :label="item"
                                                :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-col>
                                </el-row>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="学历要求" class="boxHei" prop="educational_require">
                            <el-select class="boxWid" v-model="postForm.educational_require" placeholder="请选择学历要求">
                                <el-option
                                    v-for="(item, index) in eduList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="工作经验" class="boxHei" prop="work_experience">
                            <el-select class="boxWid" v-model="postForm.work_experience" placeholder="请选择工作经验">
                                <el-option
                                    v-for="(item, index) in workList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" class="boxHei" prop="sex_require">
                            <el-select class="boxWid" v-model="postForm.sex_require" placeholder="请选择性别">
                                <el-option
                                    v-for="(item, index) in sexList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="证书要求" class="boxHei" prop="designation_confim">
                            <el-select @change="desChange" ref="des" multiple filterable allow-create default-first-option class="boxWid" v-model="postForm.designation_confim" placeholder="请选择标签或者输入，回车添加自定义">
                                <el-option
                                    v-for="(item, index) in desList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="技能要求" class="boxHei">
                            <el-select @change="skilChange" multiple filterable allow-create default-first-option class="boxWid" v-model="postForm.skil_require" placeholder="请选择标签或者输入，回车添加自定义">
                                <el-option
                                    v-for="(item, index) in skilList"
                                    :key="index"
                                    :label="item"
                                    :value="item">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="职位描述">
                             <el-input
                                type="textarea"
                                :autosize="{ minRows: 5}"
                                placeholder="请输入职位描述"
                                v-model="postForm.job_description">
                            </el-input>
                            <div class="miaoshuTips" v-if="postForm.job_name">
                                <div class="clearfix" style="width: 30%">
                                    <el-link v-if="postForm.job_name" icon="el-icon-view" type="primary" @click="see">看看别人怎么写</el-link>
                                    <div class="fr">
                                        <el-link type="primary" @click="changeTips" v-if="showTips">换一换</el-link>
                                        <el-link type="primary" @click="useTips" v-if="canChangeTip" style="margin-left: 10px;">使用</el-link>
                                    </div>
                                </div>
                                <div v-html="showTips" class="showTips">{{showTips}}</div>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-form>
            </el-row>
            <div class="submit">
                <el-button type="primary" @click="submit">保存并提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: true,
                jid: '',
                postForm: {},
                jobNameList: ["主班老师","乐高老师","书法老师","亲子老师","体育老师","作文老师","保健医生","保安","保教主任","保洁","保育员","创客老师","副园长","副班老师","厨师","司机","后勤主任","园长","园长助理","外教老师","实习生","家庭教育老师","幼教老师","感统老师","托育老师","拼音老师","教学主任","数学老师","早教老师","校长","测评师","生活老师","编程老师","美术老师","自定义","舞蹈老师","英语老师","蒙氏老师","行政老师","课程营销","课程顾问","速算导师","钢琴老师","音乐老师"],
                peoNumList: ["1人","2人","3~5人","5~10人","10~20人","20人以上"],
                // 最小工资
                moneyMinList: ['面议', 500, 1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000, 10000, 11000, 12000, 13000, 14000, 15000, 16000, 17000, 18000, 19000, 20000, 21000, 22000, 23000, 24000, 25000, 26000, 27000, 28000, 29000, 30000],
                moneyMaxList: [],
                // 学历
                eduList: ["不限","中专","初中","大专","本科","本科以上","高中"],
                // 工作经验
                workList: ["1年","2年","3年","4年","5年","8年","10年","10年以上","不限"],
                // 性别
                sexList: ["不限","女","男"],
                // 证书要求
                desList: ["保健医证","保育员证","医师资格证","园长证","教师资格证","暂无要求","育婴师证"],
                // 技能要求
                skilList: ["不限","亲和力","口才好","唱歌","弹琴","形象好","懂管理","懂英语","手艺活","普通话","有创意","绘画","自定义","蒙特梭利","讲故事","跳舞","高学历"],

                // 看看别人怎么写
                textAreaArray: [
                    {
                        name: "生活老师",
                        contents: [
                        "1、热爱教育事业，能够协助园长开展相关工作;\n2、有责任心、细心指导学生搞好个人卫生，培养良好的生活习惯，逐步提高学生的生活自理能力;\n3、有良好的沟通能力，亲和力强，具有良好敬业精神;\n",
                        "负责班级的保育工作协助主副班老师开展教育教学工作；完成领导交给的其它园务工作；对孩子有爱心，能吃苦耐劳。",
                        "1、在保健医生和主班教师指导下对本班幼儿进行生活护理，照顾幼儿一日生活起居;\n2、清理班级和分担区域环境卫生，对班级物品消毒、整理和保管;\n3、协助班级教师进行幼儿常规教育，引导幼儿养成良好的生活卫生习惯;\n4、协助班级教师进行各种大型活动的环境、卫生准备，共同维护良好的班集体形象;\n 5、参加保育员培训和学习，不断提升自身素质。\n",
                        "1、负责本班环境卫生。\n2、负责班内消毒工作。\n3、负责进餐时的清洁与收拾。\n4、负责配合班内老师照顾幼儿。\n 5、在保健人员的指导下，注意观察，消除安全隐患。\n必须具备保育证",
                        `岗位职责：\n
                        1、安全工作\n
                        （1）及时清除不安全隐患，确保幼儿在园期间的安全；\n
                        （2）发现问题及处理，并向班主任报告。\n
                        2、卫生保健工作\n
                        （1）负责本班室内外环境清洁，做到无死角；\n
                        （2）根据卫生保健制度认真做好本班内的卫生消毒工作；（玩具、图书、餐巾、水杯、桌椅
                        及幼儿被褥等）；掌握卫生消毒的要求与方法；\n
                        （3）每天观察本班幼儿的精神状况，发现问题及时向班主任、保健医报告；\n
                        （4）配合教师培养幼儿良好的卫生习惯，配合教师做好幼儿五官保健工作；\n
                        （5）照顾体弱、肥胖儿及个别幼儿；\n
                        （6）进餐时观察幼儿，掌握幼儿的进食量；\n
                        （7）做好幼儿的保育工作，根据气候变化做好防暑、保暖工作。\n
                        3、保教工作\n
                        （1）积极主动向带班教师了解、明确幼儿一日活动内容及目标。认真做好活动前的准备工作、\n
                        活动中的配合工作及物品管理工作；\n
                        （2）中大班保育员在教师指导下负责培养值日生工作；\n
                        （3）配合教师做好本班自然角的管理工作；配合教师制作玩教具，布置环境；\n
                        （4）配合教师做好家园配合工作；单独辅导特殊儿童的学习生活。\n
                        4、物品管理\n
                        （1）在班长的领导下，保管本班设备、玩具物品，建立物品登记；\n
                        （2）每周清点一次本班的固定资产，如发现损坏、丢失，要及时报修并填写报修单、报损申
                        请，并做好物品登记备案；\n
                        （3）负责本班幼儿衣物的保管工作；\n
                        （4）离岗前，对本班各种物品进行交接；\n
                        如遇调班，必须先清查财产，办理交接手续；非经许可不得带走班内固定财产。`,
                        `任职要求：\n
                        1、身体健康，有爱心，责任心，有大型幼儿园保育员工作经验者优先； \n
                        2、自己育有孩子，年龄在40岁以下。\n
                        3、持有保育员资格证或幼师资格证，有早教经验者优先。\n
                        岗位职责：\n
                        1、配合班级老师，全面、细致地照顾幼儿每日生活，培养幼儿良好的行为习惯和生活卫生习惯；  \n
                        2、在本班老师指导下严格执行幼儿安全、卫生保健制度。\n
                        3、负责本班和公共卫生区的清洁、消毒、安全排查等工作。 \n 
                        4、了解班级孩子，对不同体质的幼儿制定并执行不同的护理计划。 \n
                        5、配合班级老师开展教育、教学计划。`,
                        `岗位职责\n
                        1、协助主教老师进行上课与开展课间活动。\n
                        2、细心指导学生做好个人卫生，培养学上良好的生活习惯，提升学生的生活自理能力；\n
                        3、协助校区开展相关教学和教学服务工作；\n
                        4、按照教学服务标准及时主动与家长反馈学生在校情况。\n
                        岗位要求\n
                        1、英语专业毕业，英语教育、学前教育、师范类英语专业毕业；\n
                        2、喜欢小朋友，有爱心、性格开朗；\n
                        3、有一定的舞蹈、绘画、手工基础；\n
                        4、具有一定的沟通能力和组织能力；\n
                        5、具有早教经验和持有保育证者优先考虑。`,
                        `岗位职责：\n
                        1、照看班级孩子；\n
                        2、负责班上环境卫生；\n
                        3、协助班级管理。\n
                        任职要求：\n
                        1、有爱心讲卫生；\n
                        2、配合度高；\n
                        3、懂得一些育儿知识。\n`,
                        `岗位职责：\n
                        1、负责本班的清洁卫生工作。\n
                        2、配合教师对幼儿进行教育，培养幼儿良好的生活卫生习惯；\n
                        3、管理好幼儿生活，做好幼儿的生活护理工作；\n
                        4、热爱教育事业，工作积极主动、责任心强。`,
                        `1、热爱教育事业，能够协助园长开展相关工作;\n
                        2、有责任心、细心指导学生搞好个人卫生，培养良好的生活习惯，逐步提高学生的生活自理能力;\n
                        3、有良好的沟通能力，亲和力强，具有良好敬业精神。`,
                        `岗位职责：\n
                        1、热爱本职工作，全心全意为幼儿服务；热爱幼儿，坚持正面教育。\n
                        2、认真做好每天常规工作，根据幼儿、家长的需求，主动做好保育、服务工作。\n
                        3、负责园舍、设备、环境班级的清洁卫生工作；做好物品、用具、设备等的保洁、消毒工作。\n
                        4、了解班级幼儿生活习惯、健康状况、个性特点及教师教育要求。\n
                        任职资格：\n
                        1、专科及以上学历，必需具有保育员证；\n
                        2、具有1年以上幼教教学经验者优先考虑；\n
                        3、具有一定的工作经验，亲和力强；\n
                        4、熟悉儿童生活习性，了解儿童心理；\n
                        5、具有一定的文艺表演能力，普通话标准，口齿伶俐；\n
                        6、热爱教育事业，工作积极主动、责任心强。`,

                        ],
                        index: 0
                    },
                    {
                        name: "副班老师",
                        contents: [
                        "1、能够与家长沟通，解答家长早教专业问题;\n2、热爱婴幼儿教育事业，富有爱心，有责任心;\n",
                        `1、能够与家长沟通，解答家长早教问题;
                        2、热爱婴幼儿教育事业，富有爱心，有责任心;`,
                        `岗位职责
                        1、协助主教老师进行上课与开展课间活动。
                        2、细心指导学生做好个人卫生，培养学上良好的生活习惯，提升学生的生活自理能力；
                        3、协助校区开展相关教学和教学服务工作；
                        4、按照教学服务标准及时主动与家长反馈学生在校情况。
                        `,
                        `任职要求：
                        1. 思想政治素质良好，热爱幼教工作，身心健康；
                        2. 有耐心有爱心，工作踏实、细致认真；
                        3. 有团队意识、有奉献精神；
                        4. 有幼教相关经验优先。
                        `,
                        `1、能够与家长沟通，解答家长早教专业问题;
                        2、热爱婴幼儿教育事业，富有爱心，有责任心;
                        3、配合好主班的日常工作`,
                        `配班教师岗位职责：
                        1、配合主班教师完成班内的日常教学工作；
                        2、配合主班教师安排班内幼儿一日生活；
                        3、配合主班教师，做好家园共育工作。
                        配班教师任职资格：
                        1、大专及以上学历，1年以上幼儿园配班经验，有教师资格证、普通话证。
                        2、喜欢孩子，亲和力好，热爱幼教行业；
                        3、工作态度积极，有上进心；
                        4、具有良好的团队合作意识和责任心。
                        根据情况解决部分教师住宿`,
                        `1、具备婴幼儿日常护理知识；
                        2、责任心强、热爱婴幼儿，愿意为婴幼儿、家长服务；
                        3、性情温和、耐心、细致、勤劳；
                        4、具备较强的沟通表达能力。`,
                        `要求：
                        1．热爱幼教事业，有责任心、团队精神和奉献精神
                        2．学前教育中专及以上学历，具有幼儿教师资格证书者优先
                        3．有1-2年教学经验
                        4．有音乐、舞蹈、美术、英语等特长者优先录用。
                        `,
                        `岗位职责： 
                        1、协助主班完成班级的各项任务和园内布置的各项任务。
                        2、负责班级内幼儿的日常教学和幼儿的管理工作； 
                        3、认真执行卫生、保健、安全工作程序，确保幼儿安全与健康； 
                        4、认真组织教育教学工作，促进幼儿全面发展； 
                        5、积极参加幼儿园各项教研、学习、培训、文体活动；
                        `,
                        `1、协助主班教师拟定教学计划实施教学活动；
                        2、协助主班教师布置教学环境、制作教具；
                        3、维护学生在学校的健康与管理，辅导学生的身心发展；
                        4、参加老师教研活动和进修活动。
                        任职要求：
                        1. 身体健康，有爱心，热爱小朋友，热爱生活；
                        2. 能胜任岗位工作，具有一定的执行力；
                        3. 积极上进，有团队合作精神。`,
                        `岗位职责：
                        1. 辅助班主任完成教学任务与目标；
                        2. 根据要求准备课上教具，保证授课质量；
                        3. 教室及教具的维护和管理；
                        4. 主管安排的其他相关工作；
                        岗位要求：
                        1. 学前教育/师范类/英语专业等；
                        2. 有爱心,喜欢和小朋友在一起的工作；
                        3. 优秀的沟通,协调能力， 良好的领导能力；
                        4. 有婴幼儿工作经验者优先录用。`
                        ],
                        index: 0
                    },
                    {
                        name: "主班老师",
                        contents: [
                        "1、熟悉儿童生活习性，了解儿童心理;\n2、工作积极主动、责任心强、会唱歌、跳舞;\n3、严格执行作息制度，合理安排并组织幼儿整天生活\n",
                        `岗位职责：
                        1、幼儿园的教学工作
                        2、负责幼儿园的家庭教育指导工作；
                        3、负责幼儿园的亲子早教工作；
                        4、收集、整理家园教育资料，并及时归档。
                        任职资格：
                        1、专科及以上学历，心理学、幼儿教育等相关专业；
                        2、具有2年以上幼教教学经验者优先考虑；
                        3、具有一定的管理经验，亲和力强；
                        4、熟悉儿童生活习性，了解儿童心理；
                        5、具有一定的文艺表演能力，普通话标准，口齿伶俐；
                        6、热爱教育事业，工作积极主动、责任心强。`,
                        `1.踏实肯干， 喜欢和孩子一起工作，
                        2.能够承受相应的工作压力:
                        3.身体健康，精力充沛;
                        4.良好的沟通、协调和语言能力
                        5.优秀的领导力，具有团队合作精神;
                        6.为人正直，具有良好的职业素养;
                        7.有儿童教育行业相关工作经验优先。
                        `,
                        `任职要求：
                        （1） 教育类专业大专或以上学历；
                        （2） 有2年或以上主班老师工作经验；
                        （3） 持有蒙台梭利证书、育婴师证、保育员证、教师资格证优先考虑；
                        （4） 能独立完成亲子早教课程优先考虑；
                        （5） 早教机构经验优先。
                        `,
                        `工作岗位职责：
                        1、协助幼儿园内的后勤服务工作；
                        2、负责幼儿园的家庭教育指导工作；
                        3、负责幼儿园的亲子早教工作；
                        4、收集、整理家园教育资料，并及时归档。
                        任职资格：
                        1、有大专以上学历及教师资格证，有电脑基础优先；
                        2、具有1年以上幼教教学经验者优先；
                        3、具有一定的班级管理经验，亲和力强；
                        4、熟悉儿童生活习性，了解儿童心理；
                        5、具有一定的文艺表演能力，普通话标准，口齿伶俐；
                        6、热爱教育事业，工作积极主动、责任心强。`,
                        `任职要求：
                        1. 思想政治素质良好，热爱幼教工作，身心健康；
                        2. 有耐心有爱心，工作踏实、细致认真；
                        3. 有团队意识、有奉献精神；
                        4. 有幼教带班经验2年以上。`,
                        `（1）幼儿教育校院毕业，本科以上学历，有教师资格证书、普通话证、健康证；
                        （2）5年以上工作经验，有3年以上班长工作经验，喜爱幼儿教育事业；
                        （3）形象气质好，亲和力佳，沟通能力强；
                        （4）协助教学主任进行课程研发及课程实施；
                        （5）有良好的语言组织和表达能力，积极进取，善于用英语进行沟通；
                        （6）工作有韧性，能够承受高强度的工作压力。
                        职责描述：
                        （1） 根据日托中心教学规划，组织班级教师实施幼儿日常教育教学活动；
                        （2） 积极参加园所教研及各种学习活动，提高教育教学质量；
                        （3）针对幼儿的在日托中心表现及定期测评进行家长沟通工作，定期组织班级家长会；
                        （4）负责班级其他教师的教学指导、培训、监督、考核；
                        （5）观察孩子、了解孩子的心理成长，在实践中提高教学能力；
                        （6）有效开展指导家长工作，认真填写交接记录，做好家园共育；
                        （7）服从工作调配，执行上级交办的其它工作等。`,
                        `主班教师岗位职责:
                        1、组织班级实施幼儿日常教育教学活动，参加教研及各种学习活动，提高教育教学质量；
                        2、针对幼儿在园表现与家长进行沟通，组织班级家长会，开展家园共育；
                        3、负责班级其他教师的教学指导、培训、监督、考核；
                        4、根据幼儿园教学规划，组织班级教师实施教学计划；
                        5、服从工作调配,执行上级交办的其它工作等。
                        主班教师任职资格：
                        1、学前教育等相关专业毕业优先；
                        2、有幼儿园教师资格证书、普通话证。
                        3、形象气质好，亲和力佳，沟通能力强；
                        4、有良好的语言组织和表达能力，积极进取；
                        5、工作有韧性，能够承受高强度的工作压力。`,
                        `1、为人正直、忠诚、善良，有极强的团队精神；
                        2、性格活泼开朗，有爱心，喜欢和小朋友一起工作；
                        3、形象端庄大方，具备幼儿园或早教从业经验；
                        4、幼儿师范、学前教育等专业毕业（优秀应届毕业生亦可）。`,
                        `1，踏实，肯干，认真负责。
                        2、有较强的抗压能力。
                        3、可以很好的组织一日生活以及教学活动。
                        4、做好家长沟通工作。
                        5、能够按时完成上级交给的任务。`,
                        `1、有工作经验者优先，随时上班
                        2、有爱心，有耐心，有责任心，能吃苦耐劳，热爱学前教育事业
                        3、积极与家长沟通，做好家园共育工作
                        4、能做好幼儿园一日工作的组织与安排`
                        ],
                        index: 0
                    },
                    {
                        name: "教学主任",
                        contents: [
                        "1、协助教学园长工作，负责幼儿园教育教学的全面管理与指导工作;\n2、负责幼儿园教学的全面规划及管理，协助园长组织幼儿园大型活动的策划与实施;\n3、负责教师的教学指导、培训、监督、考核，指导幼儿教师进行幼儿园环境创设\n"],
                        index: 0
                    },
                    {
                        name: "保育员",
                        contents: [
                        "1、在保健医生和主班教师指导下对本班幼儿进行生活护理，照顾幼儿一日生活起居;\n2、清理班级和分担区域环境卫生，对班级物品消毒、整理和保管;\n3、协助班级教师进行幼儿常规教育，引导幼儿养成良好的生活卫生习惯;\n4、协助班级教师进行各种大型活动的环境、卫生准备，共同维护良好的班集体形象;\n5、参加保育员培训和学习，不断提升自身素质\n",
                        "负责班级的保育工作协助主副班老师开展教育教学工作；完成领导交给的其它园务工作；对孩子有爱心，能吃苦耐劳。",
                        "1、在保健医生和主班教师指导下对本班幼儿进行生活护理，照顾幼儿一日生活起居;\n2、清理班级和分担区域环境卫生，对班级物品消毒、整理和保管;\n3、协助班级教师进行幼儿常规教育，引导幼儿养成良好的生活卫生习惯;\n4、协助班级教师进行各种大型活动的环境、卫生准备，共同维护良好的班集体形象;\n 5、参加保育员培训和学习，不断提升自身素质。\n",
                        "1、负责本班环境卫生。\n2、负责班内消毒工作。\n3、负责进餐时的清洁与收拾。\n4、负责配合班内老师照顾幼儿。\n 5、在保健人员的指导下，注意观察，消除安全隐患。\n必须具备保育证",
                        `岗位职责：\n
                        1、安全工作\n
                        （1）及时清除不安全隐患，确保幼儿在园期间的安全；\n
                        （2）发现问题及处理，并向班主任报告。\n
                        2、卫生保健工作\n
                        （1）负责本班室内外环境清洁，做到无死角；\n
                        （2）根据卫生保健制度认真做好本班内的卫生消毒工作；（玩具、图书、餐巾、水杯、桌椅
                        及幼儿被褥等）；掌握卫生消毒的要求与方法；\n
                        （3）每天观察本班幼儿的精神状况，发现问题及时向班主任、保健医报告；\n
                        （4）配合教师培养幼儿良好的卫生习惯，配合教师做好幼儿五官保健工作；\n
                        （5）照顾体弱、肥胖儿及个别幼儿；\n
                        （6）进餐时观察幼儿，掌握幼儿的进食量；\n
                        （7）做好幼儿的保育工作，根据气候变化做好防暑、保暖工作。\n
                        3、保教工作\n
                        （1）积极主动向带班教师了解、明确幼儿一日活动内容及目标。认真做好活动前的准备工作、\n
                        活动中的配合工作及物品管理工作；\n
                        （2）中大班保育员在教师指导下负责培养值日生工作；\n
                        （3）配合教师做好本班自然角的管理工作；配合教师制作玩教具，布置环境；\n
                        （4）配合教师做好家园配合工作；单独辅导特殊儿童的学习生活。\n
                        4、物品管理\n
                        （1）在班长的领导下，保管本班设备、玩具物品，建立物品登记；\n
                        （2）每周清点一次本班的固定资产，如发现损坏、丢失，要及时报修并填写报修单、报损申
                        请，并做好物品登记备案；\n
                        （3）负责本班幼儿衣物的保管工作；\n
                        （4）离岗前，对本班各种物品进行交接；\n
                        如遇调班，必须先清查财产，办理交接手续；非经许可不得带走班内固定财产。`,
                        `任职要求：\n
                        1、身体健康，有爱心，责任心，有大型幼儿园保育员工作经验者优先； \n
                        2、自己育有孩子，年龄在40岁以下。\n
                        3、持有保育员资格证或幼师资格证，有早教经验者优先。\n
                        岗位职责：\n
                        1、配合班级老师，全面、细致地照顾幼儿每日生活，培养幼儿良好的行为习惯和生活卫生习惯；  \n
                        2、在本班老师指导下严格执行幼儿安全、卫生保健制度。\n
                        3、负责本班和公共卫生区的清洁、消毒、安全排查等工作。 \n 
                        4、了解班级孩子，对不同体质的幼儿制定并执行不同的护理计划。 \n
                        5、配合班级老师开展教育、教学计划。`,
                        `岗位职责\n
                        1、协助主教老师进行上课与开展课间活动。\n
                        2、细心指导学生做好个人卫生，培养学上良好的生活习惯，提升学生的生活自理能力；\n
                        3、协助校区开展相关教学和教学服务工作；\n
                        4、按照教学服务标准及时主动与家长反馈学生在校情况。\n
                        岗位要求\n
                        1、英语专业毕业，英语教育、学前教育、师范类英语专业毕业；\n
                        2、喜欢小朋友，有爱心、性格开朗；\n
                        3、有一定的舞蹈、绘画、手工基础；\n
                        4、具有一定的沟通能力和组织能力；\n
                        5、具有早教经验和持有保育证者优先考虑。`,
                        `岗位职责：\n
                        1、照看班级孩子；\n
                        2、负责班上环境卫生；\n
                        3、协助班级管理。\n
                        任职要求：\n
                        1、有爱心讲卫生；\n
                        2、配合度高；\n
                        3、懂得一些育儿知识。\n`,
                        `岗位职责：\n
                        1、负责本班的清洁卫生工作。\n
                        2、配合教师对幼儿进行教育，培养幼儿良好的生活卫生习惯；\n
                        3、管理好幼儿生活，做好幼儿的生活护理工作；\n
                        4、热爱教育事业，工作积极主动、责任心强。`,
                        `1、热爱教育事业，能够协助园长开展相关工作;\n
                        2、有责任心、细心指导学生搞好个人卫生，培养良好的生活习惯，逐步提高学生的生活自理能力;\n
                        3、有良好的沟通能力，亲和力强，具有良好敬业精神。`,
                        `岗位职责：\n
                        1、热爱本职工作，全心全意为幼儿服务；热爱幼儿，坚持正面教育。\n
                        2、认真做好每天常规工作，根据幼儿、家长的需求，主动做好保育、服务工作。\n
                        3、负责园舍、设备、环境班级的清洁卫生工作；做好物品、用具、设备等的保洁、消毒工作。\n
                        4、了解班级幼儿生活习惯、健康状况、个性特点及教师教育要求。\n
                        任职资格：\n
                        1、专科及以上学历，必需具有保育员证；\n
                        2、具有1年以上幼教教学经验者优先考虑；\n
                        3、具有一定的工作经验，亲和力强；\n
                        4、熟悉儿童生活习性，了解儿童心理；\n
                        5、具有一定的文艺表演能力，普通话标准，口齿伶俐；\n
                        6、热爱教育事业，工作积极主动、责任心强。`,
                        ],
                        index: 0
                    },
                    {
                        name: "园长助理",
                        contents: [
                        "1、协助园长，完成园长职责;\n2、负责教学管理工作指导，教学工作人员进行思想教育，检查各种制度的落实情况。\n3、组织家长工作，定期开展家长会，家长开放日、家访，家长工作坊活动，并做好记录。\n4、做好职工政治思想工作，关心教职工的生活，倾听教职工的意见，并向园长提出合理化的建议，稳步提高办园保教质量。\n"],
                        index: 0
                    },
                    {
                        name: "实习生",
                        contents: [
                        "1、中专以上学历，学前教育专业;\n2、无经验亦可，持有教师资格证优先考虑;\n3、吃苦耐劳，有责任心，有爱心，不爱计较，有团队合作精神;\n"],
                        index: 0
                    },
                    {
                        name: "保健医生",
                        contents: [
                        "1、医学、幼儿护理专业;\n2、有处理儿童突发疾病和意外事故的技术和能力，熟练掌握儿童营养学知识，具备保健医的基本素质;\n3、有保健医证，有医师证或营养师证者优先;\n4、爱孩子，有耐心，责任心强，有良好的敬业精神和职业道德操守\n"],
                        index: 0
                    },
                    {
                        name: "副园长",
                        contents: [
                        "1、实施各项招生及运营管理工作，确保园所经营指标有效达成;\n2、制定园所发展规划及学期、月度园务工作计划与目标;\n3、合理配置园所人力资源，确保团队执行力;\n4、负责涉外相关工作，协调维护与上级主管部门的良好关系\n"],
                        index: 0
                    },
                    {
                        name: "园长",
                        contents: [
                        "1、全面负责幼儿园的管理、保教、安全、经营等工作;\n2、制订幼儿园工作计划，定期召开国务会议，抓好幼教的各个环节，保证幼儿教育质量;\n3、贯彻执行国家有关教育的法律、法规、方针、政策、上级主管部门的规定，依法治教，依法办园;\n4、制定学年工作计划，并组织实施。针对计划执行情况，结合实陆路工作作好总结;\n5、审核预算、决算，合理安排各项收支，定期听取财务汇报。策划、配置园舍设施、设备，营造良好的教养环境;\n6、重视安全工作，采取有效的安全措施，无事故;\n7、完善建立教育研究、业务档案、财务管理、园务会议、人员奖罚、安全管理等制度，按时收集各类资料，并接受上级检查;\n8、保证幼儿园经营指标的完成，做好对外宣传，扩大招生范围\n9、坚持勤俭办园的方针，管理好园舍、设备、经费和园内绿化，增收节支。\n"],
                        index: 0
                    },
                    {
                        name: "舞蹈老师",
                        contents: [
                        "1、让孩子认识身体各部位的同时，增强舞蹈方向感，做到初步简单动作协调;\n2、逐步规范舞蹈姿态，基本做到腿直、脚绷、背挺;\n3、增强孩子对音乐律动的感觉，提高学习舞蹈的兴趣;\n4、发展幼儿柔韧性和协调性，帮助树立孩子的勇敢自信;\n5、培养孩子舞台感觉及团结友爱合作意识。\n"],
                        index: 0
                    },
                    {
                        name: "英语老师",
                        contents: [
                        "1、全英文授课，提前2-3天完成备课内容;\n2、每单元安排复习和测试，并将测试过程排成视频发于家长;\n3、负责班级稳定，提高续班率;\n4、发现并处理日常教学过程中其他问题;\n5、协助校内外相关活动\n6、组织试听课演示。\n"],
                        index: 0
                    },
                    {
                        name: "音乐老师",
                        contents: [
                        "1、让孩子了解音乐结构、音乐内容;\n2、学习使用不同的速度、力度、音色变化、表现歌曲的不同的形象内容;\n3、使用固定节奏型，随熟悉的歌曲或乐器演奏，在集体中学习保持与音乐，与他人协调一致，为歌曲或乐曲选择合适的节奏型和音乐;\n4、学习分辨音乐中比较明显的高低、快慢、强弱、音色变化，体验这些变化所表达的情意，体验倾听和欢赏活动的快乐。\n"],
                        index: 0
                    },
                    {
                        name: "钢琴老师",
                        contents: [
                        "1、结合幼儿年龄特点，对每一孩子的钢琴技艺全面负责;\n2、关怀、接纳、尊重的态度与幼儿交往，因为而异，因材施教;\n3、通过观察了解每一位幼儿个体差异，逐一制定钢琴教学计划和目标，编制好适宜的练习曲目;\n4、合理有效的组织幼儿练琴活动，一对一的教学模式，保证幼儿每天练琴时间不得少于10-15分钟\n5、认真填写钢琴授课记录，并认真记录好每一个幼儿的授课和练琴进展情况，发现问题及时调整教学方法，确保授课质量和学琴效果\n6、做好与家长沟通工作，做好每周五钢琴课本的工作，详细汇报幼儿在园学琴表现以及掌握情况，认真听取家长提出的宝贵建议，做好完园教育的一致性。\n"],
                        index: 0
                    },
                    {
                        name: "体育老师",
                        contents: [
                        "1、具有高度的幼教职业兴趣、教学热诚;\n2、肯于学习，勇于挑战，具有较好的抗压度及承受度;\n3、师范类、体育类及教育相关专业。\n"],
                        index: 0
                    },
                    {
                        name: "美术老师",
                        contents: [
                        "1、在教学中突出创意美术的特点：想想、看看、做做、画画、玩玩的宗旨，让孩子们爱上我们的课堂;\n2、不断改进教学方法，课堂中注重调动学习多种感官的参与，提高学生的观察力、注意力及审美能力;\n3、可根据自身的所长，多积极组织学生开展课外美术活动，参加各级比赛，多得奖。\n"],
                        index: 0
                    },
                    {
                        name: "保安",
                        contents: [
                        "1、认真学习有关法律和治安保卫常识，服从幼儿园的领导，遵守幼儿园的各项规章制度，严格执行幼儿园的安全、消防制度，熟悉工作流程;\n2、熟悉保安岗位职责，熟悉并掌握保安工作器械的性能及使用、保养；能熟练使用各类消防设施和各种灭火器材;\n3、做好日常保卫工作，对来访人员的询问、查验、登记工作；杜绝一切陌生人员入园；对来园访问者须问清情况，及时汇报园负责人，经同意，在门卫登记后方能入园;\n4、保安人员必须监控岗位，不随意离开岗位，幼儿接送时间，认真做好接待工作，严防幼儿走失。\n"],
                        index: 0
                    },
                    {
                        name: "保教主任",
                        contents: [
                        "1、协助园长履行园长工作的各项职责;\n2、根据园长及市、区教育行政部门的要求，制定保教工作计划，带领并指导保教人员制定好各种计划和工作总结;\n3、负责分管业务或行政后勤工作指导、帮助业务或指导后勤部门的负责人制定部门工作计划，并督促实施，检查工作，参与总结;\n4、协助园长做好保教人员思想工作和培养青年教师，鼓励并支持保教人员在教育实践中大胆创新;\n5、经常与保健室和后勤部门联系，互相支持、配合，共同搞好幼儿的保健工作和饮食营养工作。\n"],
                        index: 0
                    },
                    {
                        name: "早教老师",
                        contents: [
                        "1、落实园务工作计划，掌握婴幼儿年龄特征，结合各个年龄段宝宝年龄特点设计活动，做到动静交替，活动内容新颖、有趣，同时注重对家长的指导;\n2、管理使用好早教中心教玩具，做到摆放玩具整齐、有序，同时每学期开学要对玩具登记，期末清点玩具数量，检查玩具安全质量;\n3、早教环境干净、温馨，区域划分清晰，合理，创设富有新意的活动区，为宝宝营造一个良好的活动环境。\n"],
                        index: 0
                    },
                    {
                        name: "后勤主任",
                        contents: [
                        "1、在园长领导下负责幼儿园保育保健、膳食营养、后勤保障工作，落实园务计划及管理目标;\n2、与保教人员了解分析幼儿健康情况，对保健工作提出管理措施，认真督促和检查卫生制度;\n3、协助保教主任组织开展全国的保育工作。\n"],
                        index: 0
                    },
                    {
                        name: "司机",
                        contents: [
                        "1、有驾驶大巴车（A牌）的驾驶执照，有驾驶工作经验三年以上经验;\n2、喜欢孩子，说话语气温和，能保证接送时间;\n3、认真保养车辆，出车前，返回后，及时发现检查车辆的运行情况，保证车况良好，运行安全;\n4、能处理简单的车辆维修工作，确实需要进行车辆维修时，应报总务园长审批后，在指定的维修中心进行维修;\n5、接送幼儿不开快车，保持匀速，车辆启动到站要减速，确保幼儿的人身安全;\n6、对家长要主动热情，有晚点情况要耐心向家长做解释，配合送车教师完成好接送工作。\n"],
                        index: 0
                    },
                    {
                        name: "保洁",
                        contents: [
                        "1、负责全园环境的清洁卫生工作，保证环境及各种设施的整洁;\n2、服从领导安排，完成园内交给的各项工作。\n"],
                        index: 0
                    },
                    {
                        name: "厨师",
                        contents: [
                        "1、龄特点制作营养丰富、易于消化适合幼儿的饭菜。促进幼儿身体健康、严格遵守作息时间，按时开餐，不擅离职守、串岗、脱岗;\n2、提高烹调技术，做到色香味俱全，米饭软硬适当，花色品种多样，促进幼儿的食欲，保证营养的质量;\n3、食具餐餐消毒，熟食加盖，生熟分开，凡已腐烂变质食物不能给幼儿吃，严防食物中毒;\n4、搞好厨房的清洁卫生，保持厨房干净，整洁，每天小扫，每周大扫，厨房用具要定期。\n"],
                        index: 0
                    }
                ],
                showTips: '',
                showTipsArr: [],
                tipsPage: 1,
                canChangeTip: false,

                rules: {
                    job_name: [
                        { required: true, message: '请选择职位名称', trigger: 'change' }
                    ],
                    person_number: [
                        { required: true, message: '请选择招聘人数', trigger: 'change' }
                    ],
                    salary_package: [
                        { required: true, message: '请选择薪资待遇', trigger: 'change' }
                    ],
                    educational_require: [
                        { required: true, message: '请选择学历要求', trigger: 'change' }
                    ],
                    work_experience: [
                        { required: true, message: '请选择工作经验', trigger: 'change' }
                    ],
                    sex_require: [
                        { required: true, message: '请选择性别', trigger: 'change' }
                    ],
                    designation_confim: [
                        { required: true, message: '请选择证书要求', trigger: 'change' }
                    ]
                }
            }
        },
        mounted() {
            this.jid = this.$route.query.jid
            this.getPost()
        },
        methods:{

            // 证书要求
            desChange(o) {
                if(this.postForm.designation_confim[this.postForm.designation_confim.length -1] === '暂无要求') {
                    this.postForm.designation_confim = ['暂无要求']
                } else if(o[0] == '暂无要求') {
                    this.postForm.designation_confim.splice(0,1)
                }
            },

            // 技能要求
            skilChange(o) {
                if(this.postForm.skil_require[this.postForm.skil_require.length -1] === '不限') {
                    this.postForm.skil_require = ['不限']
                } else if(this.postForm.skil_require[0] == '不限') {
                    this.postForm.skil_require.splice(0,1)
                }
            },

            // 获取职位信息
            getPost() {
                if(this.jid) {
                    this.loading = true
                    this.api.get('/5cef3cb0c24d9', { jid: this.jid }).then(r => {
                        this.loading = false
                        this.postForm = r.data.JobInfo
                        if(this.postForm.salary_package === '面议') {
                            this.postForm.moneyMin = '面议'
                        } else {
                            this.postForm.moneyMin = this.postForm.salary_package_min
                            this.postForm.moneyMax = this.postForm.salary_package_max
                            this.moneyChange(this.postForm.moneyMin)
                        }
                        if(this.postForm.educational_require) {
                            this.postForm.educational_require = JSON.parse(this.postForm.educational_require)
                            if(typeof this.postForm.educational_require) {
                                this.postForm.educational_require = this.postForm.educational_require[0]
                            }
                        }
                        if(this.postForm.designation_confim) {
                            this.postForm.designation_confim = JSON.parse(this.postForm.designation_confim)
                        }
                        if(this.postForm.skil_require) {
                            this.postForm.skil_require = JSON.parse(this.postForm.skil_require)
                        }
                        if(this.postForm.job_description) {
                            this.postForm.job_description = this.postForm.job_description.replace(/↵/g, '\n')
                        }
                    })
                } else {
                    this.loading = false
                }
            },

            // 薪资选择
            moneyChange(e) {
                if(e === '面议') {
                    this.postForm.salary_package = '面议'
                } else {
                    let j = e+500
                    while(j < e + 500 * 29){
                        this.moneyMaxList.push(j);
                        j+=500
                    }
                    this.postForm.salary_package = e + '-' + e + 500
                }
            },

            // 薪资提交改变
            moneyMaxChange(e) {
                this.postForm.salary_package = this.postForm.moneyMin + '-' + e
            },

            // 看看别人怎么写
            see() {
                if(this.textAreaArray.filter(o=>o.name === this.postForm.job_name)[0] ) {
                    let textAreaArray = this.textAreaArray.filter(o=>o.name === this.postForm.job_name)[0].contents
                    this.showTipsArr = []
                    textAreaArray.forEach(o=>{
                        this.showTipsArr.push(o.replace(/\n/g, '<br>'))
                    })
                    this.showTips = this.showTipsArr[this.tipsPage - 1]
                    this.canChangeTip = true
                } else {
                    this.showTips = '别人还没写过' + this.postForm.job_name + '呢'
                    this.canChangeTip = false
                }
            },

            // 换一换
            changeTips() {
                if(this.showTipsArr.length !== this.tipsPage) {
                    this.tipsPage = this.tipsPage + 1
                    this.showTips = this.showTipsArr[this.tipsPage - 1]
                } else {
                    this.tipsPage = 0
                }
            },

            // 职位名称改变
            changeJobName() {
                this.showTips = ''
                this.showTipsArr = []
                this.tipsPage = 1
            },
            
            // 使用提示语
            useTips() {
                this.$set(this.postForm, 'job_description', this.showTips)
                this.postForm.job_description = this.postForm.job_description.replace(/<br>/g, '\n')
            },

            // 提交
            submit() {
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        if(this.postForm.job_description) {
                            this.postForm.job_description = this.postForm.job_description.replace(/\n/g, '↵')
                        }
                        // 5cef3cf964bcd 编辑
                        // 5ced15a0c36df 新增
                        this.api.post(this.jid?'/5cef3cf964bcd':'/5ced15a0c36df', this.postForm).then(r => {
                            this.$message({
                                message: this.jid?'修改成功':'新增成功',
                                type: 'success'
                            });
                            this.$router.back()
                        })
                    } else {
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .post {
        background: white;
        padding: 20px;
        margin-top: 20px;
        .boxWid {
            width: 100%;
        }
        .boxHei {
            height: 81px;
        }
        .miaoshuTips {
            color: #ff5b12;
            line-height: initial;
            padding-top: 5px;
            .showTips {
                color: #666;
            }
        }
        .submit {
            text-align: center;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/boss/postDetail.vue